/**
 * Hospitals Component
 *
 * Description: Displays hospital schedules including name, fees, and available timings. If `isMyProfile`
 * is true, an edit icon allows modifications to the hospital details.
 *
 * Props:
 * - isMyProfile (boolean): Shows edit icon if true.
 * - timings (IAvailability[]): Array of hospital timings.
 *
 * File Name: Hospitals.tsx
 * Date: 02-09-2024
 */

import React from "react";
import { Link } from "react-router-dom";
import edit from "../../../assets/images/awesome-edit.svg";
import { CURRENCY, weekDays } from "src/lib/constans";
import moment from "moment";
import { IAvailability } from "src/types/GlobalInterfaces";

const Hospitals: React.FC<{
  isMyProfile: boolean;
  timings: IAvailability[];
  isAdmin?: boolean;
  onEditClick?: () => void;
}> = ({
  isMyProfile = false,
  timings = [],
  isAdmin = false,
  onEditClick = () => {},
}) => {
  return (
    <div className="parent-box parent-box-margin-issue relative">
      <h2 className="font-size-20px font-Poppins-SemiBold theme-color-green">
        Hospitals
      </h2>
      {timings?.map((item, index) => (
        <div
          key={index}
          className={`hospitals-schedule ${
            index !== timings.length - 1 ? "border-b border-gray-400 pt-4" : ""
          } border-gray-300 pb-4`}
        >
          <div className="w-[90%]">
            <div className="flex items-center justify-between">
              <h2 className="font-size-20px break-all font-Poppins-SemiBold theme-color-green">
                {item.hospitalName}
              </h2>
              <p className="font-size-20px ml-4 whitespace-nowrap font-Poppins-SemiBold theme-color-green">
                {CURRENCY} {item.fees}
              </p>
            </div>
            <div className={`grid grid-cols-3 xl:grid-cols-4 gap-y-4 gap-x-6`}>
              {weekDays.map((day) => {
                // Iterate over ordered days
                const slots = timings[index]?.[day as keyof IAvailability];
                if (!slots) return null;
                return (
                  <div key={day} className="schedule">
                    <p className="font-Poppins-Regular font-size-20px capitalize">
                      {day}
                    </p>
                    {Array.isArray(slots) &&
                      slots.map(([startTime, endTime], index) => (
                        <p
                          key={index}
                          className="font-Poppins-Regular font-size-15px flex items-center gap-2"
                        >
                          <React.Fragment key={index}>
                            <span>
                              {moment(startTime, "HH:mm").format("h:mm A")}
                            </span>
                            <span>to</span>
                            <span>
                              {moment(endTime, "HH:mm").format("h:mm A")}
                            </span>
                            {/* {index < slots.length - 1 && <span>,</span>} */}
                          </React.Fragment>
                        </p>
                      ))}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
      {isMyProfile && (
        <Link
          id="edit-hospitals-btn"
          to="/physical-availability"
          className="edit-pro-icon absolute top-2 right-4"
        >
          <img src={edit} alt="edit-icon" />
        </Link>
      )}
      {isAdmin && (
        <button
          onClick={onEditClick}
          id="edit-hospitals-btn-admin"
          className="edit-pro-icon absolute top-2 right-4"
        >
          <img src={edit} alt="edit-icon" />
        </button>
      )}
    </div>
  );
};

export default Hospitals;
